import {
  faUser,
  faClipboardList,
  faExternalLinkAlt,
  faShieldAlt,
  faKey,
  faSignOutAlt,
  faCommentDots,
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Dialog, DialogActionsBar} from "@progress/kendo-react-dialogs";
import React, {useContext, useState} from "react";
import {Offcanvas} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {LOCAL_SESSION, LOCAL_TOKEN, LOCAL_PREFIX} from "../../constants/local-entity";
import {dropLocal} from "../../helpers/local-storage";
import {StoreContext} from "../../store/StoreContext";
import {createBugReport} from "../../mongo-db/bug-reports";

const version = "1.8.1"

const Profile = props => {
  const {show, close} = props;

  const navigate = useNavigate();
  const {session, setSession} = useContext(StoreContext);

  const username = (session?.username || "").toLocaleLowerCase();

  const [visibleDialog, setVisibleDialog] = useState(false);
  const [showBugForm, setShowBugForm] = useState(false);
  const [bugForm, setBugForm] = useState({title: "", description: "", type: "bug"});
  const [bugSending, setBugSending] = useState(false);
  const [bugSuccess, setBugSuccess] = useState(false);

  const handleBugSubmit = async () => {
    if (!bugForm.title.trim() || !bugForm.description.trim()) return;
    setBugSending(true);
    try {
      await createBugReport({
        ...bugForm,
        username: session?.username || "",
        name: session?.name || "",
      });
      setBugSuccess(true);
      setBugForm({title: "", description: "", type: "bug"});
      setTimeout(() => {
        setShowBugForm(false);
        setBugSuccess(false);
      }, 2000);
    } catch {
      alert("No se pudo enviar el reporte. Intente más tarde.");
    } finally {
      setBugSending(false);
    }
  };

  const handleLogout = () => {
    const keys = Object.keys(localStorage);
    for (const key of keys) {
      if (key.startsWith(LOCAL_PREFIX)) localStorage.removeItem(key);
    }
    setSession(null);
    navigate("/");
  };

  const goToPassword = () => {
    close();
    navigate("/cermaq/password");
  };

  const goToAllInspections = () => {
    if (session?.profile !== 1 && session?.profile !== 2) return;
    close();
    navigate("/cermaq/all-inspections");
  };

  const goToAdmin = () => {
    if (session?.profile !== 1) return;
    close();
    navigate("/cermaq/admin");
  };

  const goToPowerApps = () => {
    if (session?.profile !== 1) return;
    close();
    const url =
      "https://apps.powerapps.com/play/e/24f3714e-ebe9-433c-b6de-66089bbc0b33/a/5226e377-15a9-4e0e-aeb2-ec06b4e70d94?tenantId=8d885879-0da2-408d-8f73-c57d755b3cb9";
    window.open(url, "_blank").focus();
  };

  return (
    <>
      <Offcanvas show={show} onHide={close} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="fw-bold">Mi Perfil</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column">
          <div className="d-flex flex-column align-items-center mb-4">
            <div className="avatar rounded-circle bg-primary mb-3 d-flex align-items-center justify-content-center fs-1 text-white shadow-sm">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <p className="fs-6 fw-bold text-center mb-1">{session?.name || username}</p>
            <small className="text-muted">{username}</small>
          </div>

          <div className="list-group mb-4">
            {(session?.profile === 1 || session?.profile === 2) && (
              <>
                <button
                  type="button"
                  className="list-group-item list-group-item-action d-flex align-items-center gap-3 border-end-0 border-start-0 py-3"
                  style={{borderRadius: 0}}
                  onClick={() => goToAllInspections()}
                >
                  <FontAwesomeIcon icon={faClipboardList} className="text-primary-cermaq" />
                  <span>Todas las inspecciones</span>
                </button>
                {session?.profile === 1 && (
                  <>
                    <button
                      type="button"
                      className="list-group-item list-group-item-action d-flex align-items-center gap-3 border-end-0 border-start-0 py-3"
                      style={{borderRadius: 0}}
                      onClick={() => goToPowerApps()}
                    >
                      <FontAwesomeIcon icon={faExternalLinkAlt} className="text-primary-cermaq" />
                      <span>Gestor de Hallazgos y Compromisos</span>
                    </button>
                    <button
                      type="button"
                      className="list-group-item list-group-item-action d-flex align-items-center gap-3 border-end-0 border-start-0 py-3"
                      style={{borderRadius: 0}}
                      onClick={() => goToAdmin()}
                    >
                      <FontAwesomeIcon icon={faShieldAlt} className="text-primary-cermaq" />
                      <span>Administrador</span>
                    </button>
                  </>
                )}
              </>
            )}
            <button
              type="button"
              className="list-group-item list-group-item-action d-flex align-items-center gap-3 border-end-0 border-start-0 py-3"
              style={{borderRadius: 0}}
              onClick={() => goToPassword()}
            >
              <FontAwesomeIcon icon={faKey} className="text-primary-cermaq" />
              <span>Cambiar contraseña</span>
            </button>
          </div>

          <div className="mt-auto pt-4">
            <button
              type="button"
              className="btn btn-sm d-flex align-items-center gap-2 mx-auto text-muted mb-2"
              style={{fontSize: "0.78rem"}}
              onClick={() => { close(); setShowBugForm(true); }}
            >
              <FontAwesomeIcon icon={faCommentDots} className="text-primary-cermaq" />
              <span>Reportar problema o sugerencia</span>
            </button>
            <div className="d-flex align-items-center pt-2 border-top">
              <span className="fst-italic text-muted small">v{version}</span>
              <button
                type="button"
                className="btn btn-outline-danger btn-sm ms-auto d-flex align-items-center gap-2"
                onClick={() => setVisibleDialog(true)}
              >
                <FontAwesomeIcon icon={faSignOutAlt} />
                <span>Cerrar sesión</span>
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      {visibleDialog && (
        <Dialog
          title="Atención"
          onClose={() => setVisibleDialog(prev => !prev)}
        >
          <p className="fs-6 my-3 text-center">
            ¿Esta seguro que desea cerrar sesión?
          </p>
          <DialogActionsBar className="d-flex">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-danger ms-auto py-1"
                onClick={() => handleLogout()}
              >
                Cerrar sesión
              </button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
      {showBugForm && (
        <Dialog
          title="Reportar problema"
          onClose={() => { setShowBugForm(false); setBugSuccess(false); }}
          width={400}
        >
          {bugSuccess ? (
            <p className="text-success text-center my-4 fw-bold">
              Reporte enviado correctamente
            </p>
          ) : (
            <div className="p-2">
              <div className="mb-3">
                <label className="form-label fw-bold small">Tipo</label>
                <select
                  className="form-select form-select-sm"
                  value={bugForm.type}
                  onChange={e => setBugForm(prev => ({...prev, type: e.target.value}))}
                >
                  <option value="bug">Bug</option>
                  <option value="sugerencia">Sugerencia</option>
                  <option value="otro">Otro</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold small">Título</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Resumen breve del problema"
                  value={bugForm.title}
                  onChange={e => setBugForm(prev => ({...prev, title: e.target.value}))}
                  maxLength={120}
                />
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold small">Descripción</label>
                <textarea
                  className="form-control form-control-sm"
                  rows={4}
                  placeholder="Describe el problema o sugerencia con detalle..."
                  value={bugForm.description}
                  onChange={e => setBugForm(prev => ({...prev, description: e.target.value}))}
                  maxLength={1000}
                />
              </div>
            </div>
          )}
          {!bugSuccess && (
            <DialogActionsBar>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setShowBugForm(false)}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary-cermaq"
                disabled={bugSending || !bugForm.title.trim() || !bugForm.description.trim()}
                onClick={handleBugSubmit}
              >
                {bugSending ? "Enviando..." : "Enviar"}
              </button>
            </DialogActionsBar>
          )}
        </Dialog>
      )}
    </>
  );
};

export default Profile;
